import { User } from '@/api/model/user'
import { BaseModel } from '@/api/base-model'
import { ScheduledDashboardExportSchedule } from '@/api/types'
import { ScheduledDashboardExportAPI } from '@/api/backend-client'

export class ScheduledDashboardExport extends BaseModel<ScheduledDashboardExport> {
    protected collectionName = ScheduledDashboardExportAPI.collectionName

    constructor(
        public user: User|null,
        public id: string,
        public dashboardId: string,
        public schedule: ScheduledDashboardExportSchedule,
        public createdAt: Date,
        public updatedAt: Date,
    ) { super(id) }

    static fromData(data: any): ScheduledDashboardExport {
        if (data === null || typeof data === 'string' || data instanceof ScheduledDashboardExport) {
            return data
        }

        return new ScheduledDashboardExport(
            data.user ? User.fromData(data.user) : null,
            data.id,
            data.dashboardId,
            data.schedule,
            data.createdAt,
            data.updatedAt,
        )
    }
}
